import { render } from "./PendingClaimsBlock.vue?vue&type=template&id=cf093edc"
import script from "./PendingClaimsBlock.vue?vue&type=script&lang=js"
export * from "./PendingClaimsBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__